// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/fonts/Howdybun.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/fonts/Inter.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/fonts/Inter-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../public/fonts/Roboto.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../public/fonts/Roboto-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../public/fonts/WorkSans.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../public/fonts/WorkSans-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../public/icons/user-default.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Howdybun';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: "Inter";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
    font-weight: 100 900; /* variable range */
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: "Inter";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
    font-weight: 100 900;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: "Roboto";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
    font-weight: 100 900; /* variable range */
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: "Roboto";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
    font-weight: 100 900;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: "WorkSans";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
    font-weight: 100 900; /* variable range */
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: "WorkSans";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype");
    font-weight: 100 900;
    font-style: italic;
    font-display: swap;
}

:root {
    /* 🌿 Base Colours */
    --paper-white: #FFFFFF;
    --book-paper: #EFE6D2;
    --color-paper: #f7f9f3ff; /* Soft ivory, evokes aged paper */
    --color-ink: #4B4B4B; /* Graphite grey, for text and outlines */
    --color-ink-contrast: #F0F0F0; /* Off white, for text and outlines */
    --color-accent: #D94F4F; /* Cherry red, playful and tactile */
    --color-sky: #A3D5FF; /* Sky blue, gentle contrast */
    --charcoal-black: #0D0D0D;
    --charcoal-grey: #2F3437;
    --soft-near‑black: #111214;
    --baltic-amber: #FC950C;
    --deep-navy: #0A1A2F;
    --muted-navy: #2F506F;
    --ink-blue: #0F1B2D;
    --midnight-plum: #1A0F1F;
    --muted-aubergine: #2A1C2E;
    --deep-teal: #0F2A2A;
    --forest-dusk: #0E1F16;
    --letter-grey: #808080;
    --back-grey: #E0E0E0;
    --dark-grey: #A0A0A0;
    --transparent-back-grey: #E0E0E088;
    --transparent-back-navy: #0A1A2F88;
    --deep-red: #f2101e;
    --lime-green: #B5E61D;
    --oak-leaf-green: #80A74A;
    --muted-blue-grey1: #4A7E7D;
    --muted-blue-grey2: #6C7A89;
    --soft-sand: #B8AFA2;
    --taupe: #C2B9AC;
    /* 🧩 UI Roles */
    --color-background: var(--deep-navy);
    --color-foreground: var(--book-paper);
    --color-component-background: var(--book-paper);
    --color-component-foreground: var(--charcoal-grey);
    --color-component-hover-back: var(--charcoal-black);
    --color-component-hover-fore: var(--book-paper);
    --color-component-transparent-background: color-mix(in srgb, var(--book-paper) 50%, transparent);
    --color-primary: var(--color-accent);
    --color-secondary: var(--baltic-amber);
    --color-border: var(--book-paper); /* Subtle edge for cards and containers */
    --color-component-border: var(--deep-navy); /* Subtle edge for cards and containers */
    --color-shadow: rgba(0, 0, 0, 0.1);
    --color-disabled-fore: var(--letter-grey);
    --color-disabled-back: var(--back-grey);
    --color-disabled-transparent-back: var(--transparent-back-grey);
    --color-active-fore: var(--color-sky);
    --color-active-back: var(--book-paper);
    --color-hover-fore: var(--deep-navy);
    --color-hover-back: var(--book-paper);
    --color-error: var(--deep-red);
    --color-footer-back: var(--back-grey);
    --color-footer-fore: var(--deep-navy);
    --color-selected-back: var(--book-paper);
    --color-selected-fore: var(--oak-leaf-green);
    --color-overlay-back: var(--transparent-back-grey);
    --color-overlay-fore: white;
    --color-sample: var(--muted-blue-grey1);
    --color-static-background: var(--back-grey);
    --color-static: var(--transparent-back-grey);
    --color-dynamic: var(--oak-leaf-green);
    --color-region: var(--muted-navy);
    --color-progress: var(--dark-grey);
    /* ✨ States */
    --color-hover: #E85C5C; /* Slightly brighter cherry red */
    --color-active: #C13F3F; /* Deeper red for active states */
    --color-focus: #A3D5FF; /* Sky blue for focus rings */
    --color-success: var(--oak-leaf-green);
    /* 📝 Typography */
    --font-family-heading: 'Georgia', serif;
    --font-family-body: 'Roboto', sans-serif;
    --font-size-base: 16px;
    --font-size-heading: 2rem;
    --font-weight-bold: 700;
    --font-weight-regular: 400;
    /* 📐 Layout */
    --spacing-xs: 4px;
    --spacing-sm: 8px;
    --spacing-md: 16px;
    --spacing-lg: 24px;
    --spacing-xl: 32px;
    --border-radius: 6px;
    --user-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___}), var(--paper-white);
    overflow: hidden;
}

body {
    background-color: var(--color-background);
    color: var(--color-foreground);
    font-family: var(--font-family-body);
    margin: 0px;
}

.btn-outline-secondary {
    margin-left: 0.5rem;
}

/* Firefox */
.pretty-scroll.dark {
    scrollbar-width: thin;
    scrollbar-color: var(--color-foreground) transparent; /* thumb | track */
}

    /* Chrome, Edge, Safari */
    .pretty-scroll.dark::-webkit-scrollbar {
        width: 8px;
    }

    .pretty-scroll.dark::-webkit-scrollbar-track {
        background: transparent;
        border-radius: 10px;
    }

    .pretty-scroll.dark::-webkit-scrollbar-thumb {
        background-color: var(--color-foreground);
        border-radius: 10px;
        border: 2px solid transparent;
    }

        .pretty-scroll.dark::-webkit-scrollbar-thumb:hover {
            background-color: var(--color-hover);
        }

/* Firefox */
.pretty-scroll.light {
    scrollbar-width: thin;
    scrollbar-color: var(--color-component-foreground) transparent; /* thumb | track */
}

    /* Chrome, Edge, Safari */
    .pretty-scroll.light::-webkit-scrollbar {
        width: 8px;
    }

    .pretty-scroll.light::-webkit-scrollbar-track {
        background: transparent;
        border-radius: 10px;
    }

    .pretty-scroll.light::-webkit-scrollbar-thumb {
        background-color: transparent;
        border-radius: 10px;
        border: 2px solid var(--color-component-background);
    }

        .pretty-scroll.light::-webkit-scrollbar-thumb:hover {
            background-color: var(--color-component-hover-fore);
        }

/* Apply this class to any element you want to animate */
.settle-effect {
    opacity: 0;
    transform: translate(-8px, -8px) scale(1.04);
    animation: settle-in 450ms ease-out forwards;
}
/* Keyframes for the settle animation */

.spinner-border {
    border-color: var(--color-border);
    border-right-color: transparent;
    border-left-color: transparent;
}

@keyframes settle-in {
    0% {
        opacity: 0;
        transform: translate(-8px, -8px) scale(1.04);
    }

    100% {
        opacity: 1;
        transform: translate(0, 0) scale(1);
    }
}

div.modal[role="dialog"] {
    display: flex !important;
    justify-content: center;
    background: var(--transparent-back-navy);
    overflow: clip;
}

.modal-body {
    position: relative;
    flex: 1 1 auto;
    padding: var(--bs-modal-padding);
    height: 90%;
    overflow-y: auto;
}

@media (min-width:768px) {
    .modal-content {
        width: fit-content;
        max-height: 90vh;
    }

    .modal-fullscreen .modal-content {
        width: 100%;
        max-height:100%;
    }
}

@media (max-width:768px) {
    .modal-content {
        width: 90vw;
        max-height: 90vh;
    }

    .modal-fullscreen .modal-content {
        width: 100%;
        max-height: 100%;
    }
}

.modal-dialog-centered {
    justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/css/App.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,+DAA8D;IAC9D,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,+DAA2D;IAC3D,oBAAoB,EAAE,mBAAmB;IACzC,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,+DAAkE;IAClE,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,+DAA4D;IAC5D,oBAAoB,EAAE,mBAAmB;IACzC,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,+DAAmE;IACnE,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,+DAA8D;IAC9D,oBAAoB,EAAE,mBAAmB;IACzC,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,+DAAqE;IACrE,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,qBAAqB;IACrB,wBAAwB,EAAE,kCAAkC;IAC5D,oBAAoB,EAAE,yCAAyC;IAC/D,6BAA6B,EAAE,qCAAqC;IACpE,uBAAuB,EAAE,oCAAoC;IAC7D,oBAAoB,EAAE,8BAA8B;IACpD,yBAAyB;IACzB,wBAAwB;IACxB,0BAA0B;IAC1B,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,wBAAwB;IACxB,0BAA0B;IAC1B,oBAAoB;IACpB,sBAAsB;IACtB,sBAAsB;IACtB,oBAAoB;IACpB,oBAAoB;IACpB,kCAAkC;IAClC,kCAAkC;IAClC,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;IACzB,2BAA2B;IAC3B,2BAA2B;IAC3B,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,oCAAoC;IACpC,qCAAqC;IACrC,+CAA+C;IAC/C,kDAAkD;IAClD,mDAAmD;IACnD,+CAA+C;IAC/C,gGAAgG;IAChG,oCAAoC;IACpC,sCAAsC;IACtC,iCAAiC,EAAE,yCAAyC;IAC5E,0CAA0C,EAAE,yCAAyC;IACrF,kCAAkC;IAClC,yCAAyC;IACzC,uCAAuC;IACvC,+DAA+D;IAC/D,qCAAqC;IACrC,sCAAsC;IACtC,oCAAoC;IACpC,qCAAqC;IACrC,8BAA8B;IAC9B,qCAAqC;IACrC,qCAAqC;IACrC,wCAAwC;IACxC,4CAA4C;IAC5C,kDAAkD;IAClD,2BAA2B;IAC3B,uCAAuC;IACvC,2CAA2C;IAC3C,4CAA4C;IAC5C,sCAAsC;IACtC,iCAAiC;IACjC,kCAAkC;IAClC,aAAa;IACb,sBAAsB,EAAE,iCAAiC;IACzD,uBAAuB,EAAE,iCAAiC;IAC1D,sBAAsB,EAAE,6BAA6B;IACrD,sCAAsC;IACtC,kBAAkB;IAClB,uCAAuC;IACvC,wCAAwC;IACxC,sBAAsB;IACtB,yBAAyB;IACzB,uBAAuB;IACvB,0BAA0B;IAC1B,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,yEAA4E;IAC5E,gBAAgB;AACpB;;AAEA;IACI,yCAAyC;IACzC,8BAA8B;IAC9B,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA,YAAY;AACZ;IACI,qBAAqB;IACrB,oDAAoD,EAAE,kBAAkB;AAC5E;;IAEI,yBAAyB;IACzB;QACI,UAAU;IACd;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,yCAAyC;QACzC,mBAAmB;QACnB,6BAA6B;IACjC;;QAEI;YACI,oCAAoC;QACxC;;AAER,YAAY;AACZ;IACI,qBAAqB;IACrB,8DAA8D,EAAE,kBAAkB;AACtF;;IAEI,yBAAyB;IACzB;QACI,UAAU;IACd;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,6BAA6B;QAC7B,mBAAmB;QACnB,mDAAmD;IACvD;;QAEI;YACI,mDAAmD;QACvD;;AAER,wDAAwD;AACxD;IACI,UAAU;IACV,4CAA4C;IAC5C,4CAA4C;AAChD;AACA,uCAAuC;;AAEvC;IACI,iCAAiC;IACjC,+BAA+B;IAC/B,8BAA8B;AAClC;;AAEA;IACI;QACI,UAAU;QACV,4CAA4C;IAChD;;IAEA;QACI,UAAU;QACV,mCAAmC;IACvC;AACJ;;AAEA;IACI,wBAAwB;IACxB,uBAAuB;IACvB,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gCAAgC;IAChC,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI;QACI,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;AACJ;;AAEA;IACI,uBAAuB;AAC3B","sourcesContent":["@font-face {\r\n    font-family: 'Howdybun';\r\n    src: url('../../public/fonts/Howdybun.ttf') format('truetype');\r\n    font-weight: normal;\r\n    font-style: normal;\r\n}\r\n\r\n@font-face {\r\n    font-family: \"Inter\";\r\n    src: url(\"../../public/fonts/Inter.ttf\") format(\"truetype\");\r\n    font-weight: 100 900; /* variable range */\r\n    font-style: normal;\r\n    font-display: swap;\r\n}\r\n\r\n@font-face {\r\n    font-family: \"Inter\";\r\n    src: url(\"../../public/fonts/Inter-Italic.ttf\") format(\"truetype\");\r\n    font-weight: 100 900;\r\n    font-style: italic;\r\n    font-display: swap;\r\n}\r\n\r\n@font-face {\r\n    font-family: \"Roboto\";\r\n    src: url(\"../../public/fonts/Roboto.ttf\") format(\"truetype\");\r\n    font-weight: 100 900; /* variable range */\r\n    font-style: normal;\r\n    font-display: swap;\r\n}\r\n\r\n@font-face {\r\n    font-family: \"Roboto\";\r\n    src: url(\"../../public/fonts/Roboto-Italic.ttf\") format(\"truetype\");\r\n    font-weight: 100 900;\r\n    font-style: italic;\r\n    font-display: swap;\r\n}\r\n\r\n@font-face {\r\n    font-family: \"WorkSans\";\r\n    src: url(\"../../public/fonts/WorkSans.ttf\") format(\"truetype\");\r\n    font-weight: 100 900; /* variable range */\r\n    font-style: normal;\r\n    font-display: swap;\r\n}\r\n\r\n@font-face {\r\n    font-family: \"WorkSans\";\r\n    src: url(\"../../public/fonts/WorkSans-Italic.ttf\") format(\"truetype\");\r\n    font-weight: 100 900;\r\n    font-style: italic;\r\n    font-display: swap;\r\n}\r\n\r\n:root {\r\n    /* 🌿 Base Colours */\r\n    --paper-white: #FFFFFF;\r\n    --book-paper: #EFE6D2;\r\n    --color-paper: #f7f9f3ff; /* Soft ivory, evokes aged paper */\r\n    --color-ink: #4B4B4B; /* Graphite grey, for text and outlines */\r\n    --color-ink-contrast: #F0F0F0; /* Off white, for text and outlines */\r\n    --color-accent: #D94F4F; /* Cherry red, playful and tactile */\r\n    --color-sky: #A3D5FF; /* Sky blue, gentle contrast */\r\n    --charcoal-black: #0D0D0D;\r\n    --charcoal-grey: #2F3437;\r\n    --soft-near‑black: #111214;\r\n    --baltic-amber: #FC950C;\r\n    --deep-navy: #0A1A2F;\r\n    --muted-navy: #2F506F;\r\n    --ink-blue: #0F1B2D;\r\n    --midnight-plum: #1A0F1F;\r\n    --muted-aubergine: #2A1C2E;\r\n    --deep-teal: #0F2A2A;\r\n    --forest-dusk: #0E1F16;\r\n    --letter-grey: #808080;\r\n    --back-grey: #E0E0E0;\r\n    --dark-grey: #A0A0A0;\r\n    --transparent-back-grey: #E0E0E088;\r\n    --transparent-back-navy: #0A1A2F88;\r\n    --deep-red: #f2101e;\r\n    --lime-green: #B5E61D;\r\n    --oak-leaf-green: #80A74A;\r\n    --muted-blue-grey1: #4A7E7D;\r\n    --muted-blue-grey2: #6C7A89;\r\n    --soft-sand: #B8AFA2;\r\n    --taupe: #C2B9AC;\r\n    /* 🧩 UI Roles */\r\n    --color-background: var(--deep-navy);\r\n    --color-foreground: var(--book-paper);\r\n    --color-component-background: var(--book-paper);\r\n    --color-component-foreground: var(--charcoal-grey);\r\n    --color-component-hover-back: var(--charcoal-black);\r\n    --color-component-hover-fore: var(--book-paper);\r\n    --color-component-transparent-background: color-mix(in srgb, var(--book-paper) 50%, transparent);\r\n    --color-primary: var(--color-accent);\r\n    --color-secondary: var(--baltic-amber);\r\n    --color-border: var(--book-paper); /* Subtle edge for cards and containers */\r\n    --color-component-border: var(--deep-navy); /* Subtle edge for cards and containers */\r\n    --color-shadow: rgba(0, 0, 0, 0.1);\r\n    --color-disabled-fore: var(--letter-grey);\r\n    --color-disabled-back: var(--back-grey);\r\n    --color-disabled-transparent-back: var(--transparent-back-grey);\r\n    --color-active-fore: var(--color-sky);\r\n    --color-active-back: var(--book-paper);\r\n    --color-hover-fore: var(--deep-navy);\r\n    --color-hover-back: var(--book-paper);\r\n    --color-error: var(--deep-red);\r\n    --color-footer-back: var(--back-grey);\r\n    --color-footer-fore: var(--deep-navy);\r\n    --color-selected-back: var(--book-paper);\r\n    --color-selected-fore: var(--oak-leaf-green);\r\n    --color-overlay-back: var(--transparent-back-grey);\r\n    --color-overlay-fore: white;\r\n    --color-sample: var(--muted-blue-grey1);\r\n    --color-static-background: var(--back-grey);\r\n    --color-static: var(--transparent-back-grey);\r\n    --color-dynamic: var(--oak-leaf-green);\r\n    --color-region: var(--muted-navy);\r\n    --color-progress: var(--dark-grey);\r\n    /* ✨ States */\r\n    --color-hover: #E85C5C; /* Slightly brighter cherry red */\r\n    --color-active: #C13F3F; /* Deeper red for active states */\r\n    --color-focus: #A3D5FF; /* Sky blue for focus rings */\r\n    --color-success: var(--oak-leaf-green);\r\n    /* 📝 Typography */\r\n    --font-family-heading: 'Georgia', serif;\r\n    --font-family-body: 'Roboto', sans-serif;\r\n    --font-size-base: 16px;\r\n    --font-size-heading: 2rem;\r\n    --font-weight-bold: 700;\r\n    --font-weight-regular: 400;\r\n    /* 📐 Layout */\r\n    --spacing-xs: 4px;\r\n    --spacing-sm: 8px;\r\n    --spacing-md: 16px;\r\n    --spacing-lg: 24px;\r\n    --spacing-xl: 32px;\r\n    --border-radius: 6px;\r\n    --user-image: url('../../public/icons/user-default.svg'), var(--paper-white);\r\n    overflow: hidden;\r\n}\r\n\r\nbody {\r\n    background-color: var(--color-background);\r\n    color: var(--color-foreground);\r\n    font-family: var(--font-family-body);\r\n    margin: 0px;\r\n}\r\n\r\n.btn-outline-secondary {\r\n    margin-left: 0.5rem;\r\n}\r\n\r\n/* Firefox */\r\n.pretty-scroll.dark {\r\n    scrollbar-width: thin;\r\n    scrollbar-color: var(--color-foreground) transparent; /* thumb | track */\r\n}\r\n\r\n    /* Chrome, Edge, Safari */\r\n    .pretty-scroll.dark::-webkit-scrollbar {\r\n        width: 8px;\r\n    }\r\n\r\n    .pretty-scroll.dark::-webkit-scrollbar-track {\r\n        background: transparent;\r\n        border-radius: 10px;\r\n    }\r\n\r\n    .pretty-scroll.dark::-webkit-scrollbar-thumb {\r\n        background-color: var(--color-foreground);\r\n        border-radius: 10px;\r\n        border: 2px solid transparent;\r\n    }\r\n\r\n        .pretty-scroll.dark::-webkit-scrollbar-thumb:hover {\r\n            background-color: var(--color-hover);\r\n        }\r\n\r\n/* Firefox */\r\n.pretty-scroll.light {\r\n    scrollbar-width: thin;\r\n    scrollbar-color: var(--color-component-foreground) transparent; /* thumb | track */\r\n}\r\n\r\n    /* Chrome, Edge, Safari */\r\n    .pretty-scroll.light::-webkit-scrollbar {\r\n        width: 8px;\r\n    }\r\n\r\n    .pretty-scroll.light::-webkit-scrollbar-track {\r\n        background: transparent;\r\n        border-radius: 10px;\r\n    }\r\n\r\n    .pretty-scroll.light::-webkit-scrollbar-thumb {\r\n        background-color: transparent;\r\n        border-radius: 10px;\r\n        border: 2px solid var(--color-component-background);\r\n    }\r\n\r\n        .pretty-scroll.light::-webkit-scrollbar-thumb:hover {\r\n            background-color: var(--color-component-hover-fore);\r\n        }\r\n\r\n/* Apply this class to any element you want to animate */\r\n.settle-effect {\r\n    opacity: 0;\r\n    transform: translate(-8px, -8px) scale(1.04);\r\n    animation: settle-in 450ms ease-out forwards;\r\n}\r\n/* Keyframes for the settle animation */\r\n\r\n.spinner-border {\r\n    border-color: var(--color-border);\r\n    border-right-color: transparent;\r\n    border-left-color: transparent;\r\n}\r\n\r\n@keyframes settle-in {\r\n    0% {\r\n        opacity: 0;\r\n        transform: translate(-8px, -8px) scale(1.04);\r\n    }\r\n\r\n    100% {\r\n        opacity: 1;\r\n        transform: translate(0, 0) scale(1);\r\n    }\r\n}\r\n\r\ndiv.modal[role=\"dialog\"] {\r\n    display: flex !important;\r\n    justify-content: center;\r\n    background: var(--transparent-back-navy);\r\n    overflow: clip;\r\n}\r\n\r\n.modal-body {\r\n    position: relative;\r\n    flex: 1 1 auto;\r\n    padding: var(--bs-modal-padding);\r\n    height: 90%;\r\n    overflow-y: auto;\r\n}\r\n\r\n@media (min-width:768px) {\r\n    .modal-content {\r\n        width: fit-content;\r\n        max-height: 90vh;\r\n    }\r\n\r\n    .modal-fullscreen .modal-content {\r\n        width: 100%;\r\n        max-height:100%;\r\n    }\r\n}\r\n\r\n@media (max-width:768px) {\r\n    .modal-content {\r\n        width: 90vw;\r\n        max-height: 90vh;\r\n    }\r\n\r\n    .modal-fullscreen .modal-content {\r\n        width: 100%;\r\n        max-height: 100%;\r\n    }\r\n}\r\n\r\n.modal-dialog-centered {\r\n    justify-content: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
